var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 64,
      height: 64,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#37a59a;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.402,0H133.58C86.231,0,47.697,38.543,47.697,85.892v340.233c0,47.35,38.534,85.875,85.883,85.875h205.698 h13.175l9.327-9.292l93.222-93.24l9.301-9.31v-13.166v-301.1C464.303,38.543,425.769,0,378.402,0z M432.508,386.992H384.36 c-24.89,0-45.082,20.184-45.082,45.074v48.131H133.58c-29.867,0-54.08-24.213-54.08-54.072V85.892 c0-29.876,24.213-54.088,54.08-54.088h244.822c29.876,0,54.106,24.213,54.106,54.088V386.992z",
    style: {
      fill: "rgb( 55, 165, 154)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.613,278.398c-11.812,8.268-26.15,13.132-41.613,13.132c-15.472,0-29.811-4.864-41.617-13.132 c-20.644,8.858-33.319,24.456-41.057,38.213c-10.27,18.255-2.219,44.084,15.541,44.084c17.76,0,67.134,0,67.134,0 s49.368,0,67.128,0c17.76,0,25.815-25.828,15.542-44.084C330.932,302.854,318.253,287.256,297.613,278.398z",
    style: {
      fill: "rgb(( 55, 165, 154)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,274.246c30.322,0,54.896-24.56,54.896-54.888V206.21c0-30.327-24.574-54.905-54.896-54.905 c-30.328,0-54.905,24.578-54.905,54.905v13.148C201.095,249.686,225.673,274.246,256,274.246z",
    style: {
      fill: "rgb( 55, 165, 154)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.f9b5eb48e0fea02ac52756370986883b.svg";
export { ForwardRef as ReactComponent };